import { Block, Flex } from '@aloft/toolkit-sui';

import { memo, useMemo, useRef } from 'react';

import { PropertyGrid } from '../../components/PropertyGrid/PropertyGrid.tsx';
import { PropertyGridFocusProvider } from '../../components/PropertyGrid/PropertyGridFocusProvider.tsx';
import { getTabBackgroundColor } from '../../components/PropertyGrid/utils.ts';
import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { useComparablesToastAnchor } from '../../hooks/useToaster/useComparablesToastAnchor.ts';
import { selectAivArvActiveTab } from '../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { FeatureGridDataSourcesSection } from './columnSections/FeatureGridDataSourcesSection.tsx';
import { FeatureGridFeatureSections } from './columnSections/FeatureGridFeatureSections.tsx';
import { FeatureGridMainDwellingSection } from './columnSections/FeatureGridMainDwellingSection.tsx';
import { FeatureGridSiteSection } from './columnSections/FeatureGridSiteSection.tsx';
import { FeatureGridTransactionSection } from './columnSections/FeatureGridTransactionSection.tsx';
import { FeatureGridLabelColumnHeader } from './components/FeatureGridLabelColumnHeader.tsx';
import { FeatureGridToolbar } from './components/FeatureGridToolbar.tsx';

export const FeatureGridModule = memo(() => {
  const containerRef = useRef<HTMLDivElement>(null);
  useComparablesToastAnchor(containerRef, 'analysis');
  const activeTab = useAppSelector(selectAivArvActiveTab);
  const columnSections = useMemo(
    () => [
      FeatureGridDataSourcesSection,
      FeatureGridTransactionSection,
      FeatureGridSiteSection,
      FeatureGridMainDwellingSection,
      FeatureGridFeatureSections,
    ],
    [],
  );

  return (
    <PropertyGridFocusProvider>
      <Flex
        ref={containerRef}
        {...useTkv2ReferenceBarEvents()}
        flexDirection="column"
        width="100%"
        height="100%"
        gap="8px"
        paddingTop="10px"
        backgroundColor={getTabBackgroundColor(activeTab)}
      >
        <FeatureGridToolbar />
        <Block overflowX="scroll" overflowY="auto" paddingLeft="10px" paddingRight="30px">
          <PropertyGrid
            gridType="FeatureGrid"
            columnSections={columnSections}
            labelColumnHeader={<FeatureGridLabelColumnHeader />}
          />
        </Block>
      </Flex>
    </PropertyGridFocusProvider>
  );
});
